$shm_hitalama_taskmanager_column $mol_page
	status \
	tasks? /
	task*? null
	task_add? null
	raw_opened? false
	raw? \
	attr *
		^
		shm_hitalama_taskmanager_column_status <= status
	title_content /
		<= title
		<= Count $mol_view
			sub /
				<= count_label \
	tools <= head_tools /
	body <= column_body /
		<= Tasks $mol_list
			rows <= task_rows /$mol_view
		<= Raw $shm_hitalama_textarea
			value? <=> raw? \
			hint \#normal
	Add $mol_button_minor
		hint \Add task
		click? <=> task_add? null
		sub /
			<= Add_icon $mol_icon_plus
			\Добавить задачу
	Raw_open $mol_button_minor
		hint \Raw tasks
		click? <=> raw_open? null
		sub /
			<= Raw_open_icon $mol_icon_code_braces
	Raw_cancel $mol_button_minor
		title \Отмена
		click? <=> raw_cancel? null
	Raw_save $mol_button_major
		title \Сохранить
		click? <=> raw_save? null
	Task* $shm_hitalama_taskmanager_card
		task? <=> task*? null
